import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { http, formatApiError } from "@/api/http";

// Carrega os dados do link mágico de ativação.
export const useSetupToken = (token) => {
  const { t } = useTranslation();
  const [state, setState] = useState({
    loading: !!token, email: "", fullName: "",
    tokenError: token ? "" : t("setup.linkIncomplete"),
  });

  useEffect(() => {
    if (!token) {
      setState({ loading: false, email: "", fullName: "", tokenError: t("setup.linkIncomplete") });
      return undefined;
    }
    const controller = new AbortController();
    setState((previous) => ({ ...previous, loading: true, tokenError: "" }));
    http.get(`/auth/setup-info/${encodeURIComponent(token)}`, { signal: controller.signal })
      .then((response) => setState({
        loading: false, email: response.data.email,
        fullName: response.data.full_name || "", tokenError: "",
      }))
      .catch((failure) => {
        if (controller.signal.aborted) return;
        setState({ loading: false, email: "", fullName: "", tokenError: formatApiError(failure, t("setup.linkInvalid")) });
      });
    return () => controller.abort();
  }, [token, t]);

  return state;
};
